import { DocumentTable } from 'modules/components/layer25';
import { FolderListSection } from 'modules/components/layer35';
import React from 'react';



export type FilesDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FilesDetailSectionProps) => {

  return (
    <>
      <FolderListSection.FC />
      <DocumentTable.FC />
    </>
  );
};
